import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Typography,
  MenuItem,
  Select,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  // InputBase,
  // IconButton,
  CircularProgress,
} from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
import { get, find, isEmpty, orderBy } from 'lodash';
import moment from 'moment';

import { errorMessageHandler, formatAmount } from 'common/utils/helpers';
import { Box, StyledTableCell, StyledTableRow } from 'components';
import { getInvestorPayments } from 'services';
import { RootState } from 'redux-modules/store/rootState';
import { Deal } from 'redux-modules/deals/Types';

import styles from './styles';

const Transactions = () => {
  const classes = styles();

  const { dealList } = useSelector(({ Deals }: RootState) => Deals);
  const { investorDeals } = useSelector(({ Investor }: RootState) => Investor);

  const [selectedSPV, setSelectedSPV] = React.useState<string>('');
  const [open, setOpen] = React.useState<boolean>(false);
  const [paymentsList, setPaymentsList] = useState<any>([]);
  const [filteredPaymentList, setFilteredPaymentsList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleFilterClose = () => {
    setOpen(false);
  };
  const handleFilterOpen = () => {
    setOpen(true);
  };

  const getFilteredPaymentList = (spv?: string) => {
    !isEmpty(spv)
      ? setFilteredPaymentsList(
          paymentsList.filter((payment: any) => {
            if (get(payment, 'spv') === spv) return payment;
          }),
        )
      : setFilteredPaymentsList(paymentsList);
  };

  useEffect(() => {
    setIsLoading(true);
    getInvestorPayments()
      .then((res: any) => {
        setPaymentsList(
          orderBy(res, ['investmentDetail.investmentDate'], ['desc']),
        );
        setFilteredPaymentsList(
          orderBy(res, ['investmentDetail.investmentDate'], ['desc']),
        );
        setIsLoading(false);
      })
      .catch((err: any) => {
        const message: string = errorMessageHandler(err);
        setErrorMessage(message);
        setIsLoading(false);
      });
  }, []);

  return (
    <Box className={classes.transactionContainer}>
      <Box className={classes.mainHeader}>
        <Typography className={classes.mainHeaderText}>Transactions</Typography>
      </Box>
      <Box className={classes.traxTableBox}>
        <Box className={classes.traxTable}>
          <Box className={classes.traxHBox}>
            {/* <Box className={classes.searchBox}>
              <InputBase
                className={classes.inputSear}
                placeholder="Search"
                inputProps={{ 'aria-label': 'search' }}
              />
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
            </Box> */}
            <Box className={classes.filterControl}>
              <Typography variant="caption" className={classes.formLabel}>
                Deal &nbsp;&nbsp;
              </Typography>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                open={open}
                onClose={handleFilterClose}
                onOpen={handleFilterOpen}
                name="Investment"
                value={selectedSPV}
                displayEmpty
                onChange={(event: any) => {
                  setSelectedSPV(event.target.value);
                  getFilteredPaymentList(event.target.value);
                }}
                className={classes.selectBox}
                // disabled
              >
                <MenuItem value={''}>All</MenuItem>
                {dealList.map((deal: Deal) =>
                  investorDeals.includes(deal.id) ? (
                    <MenuItem value={get(deal, 'id')} key={get(deal, 'id')}>
                      SPV {get(deal, 'deal')}
                    </MenuItem>
                  ) : null,
                )}
              </Select>
            </Box>
          </Box>
          {isLoading ? (
            <Box className={classes.loader}>
              <CircularProgress color="inherit" size={40} />
            </Box>
          ) : !errorMessage ? (
            <TableContainer className={classes.tableContainer}>
              <Table
                stickyHeader
                className={classes.stikyTable}
                aria-label="customized table"
              >
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Amount </StyledTableCell>
                    <StyledTableCell>Trxn ID</StyledTableCell>
                    <StyledTableCell>Investment </StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Remarks</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!isEmpty(filteredPaymentList) ? (
                    filteredPaymentList.map((row: any) => (
                      <StyledTableRow key={row.id} className={classes.tableRow}>
                        <StyledTableCell>
                          {' '}
                          {moment(
                            get(row, 'investmentDetail.investmentDate'),
                          ).format('DD-MM-YYYY')}
                        </StyledTableCell>
                        <StyledTableCell>
                          {' '}
                          {formatAmount(get(row, 'amount', 0))}
                        </StyledTableCell>
                        <StyledTableCell>
                          {get(row, 'transactionId') ||
                            get(row, 'investmentDetail.transactionId') ||
                            '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          SPV {get(find(dealList, { id: row?.spv }), 'deal')}
                        </StyledTableCell>
                        {!row.approvedByAdmin ? (
                          <StyledTableCell>
                            <span>{'Confirmation pending'}</span>
                          </StyledTableCell>
                        ) : (
                          <StyledTableCell>
                            <span style={{ color: 'green' }}>
                              {'Confirmed'}
                            </span>
                          </StyledTableCell>
                        )}
                        <StyledTableCell>
                          <Typography
                            variant="caption"
                            className={classes.remarkText}
                          >
                            {get(row, 'remarks') || 'No Remarks'}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={6}>
                        <Typography
                          variant="body1"
                          className={classes.noRecordText}
                        >
                          No Records Found
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body1" className={classes.errorMessage}>
              {errorMessage}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default Transactions;
